import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../store";
import { useNavigate } from "react-router-dom";
import { getFormGroup, rmvMsgSccsFGr } from "../../store/feature/formGroup";

// icon
import AddIcon from "@mui/icons-material/Add";
import Toast from "../../components/atoms/toast";
import AdminUserRoleTable from "../../components/molecules/adminUserRole/AdminUserRoleTable";
import AdminUserRoleSearch from "../../components/molecules/adminUserRole/AdminUserRoleSearch";
import {
  getAdminUserRolesList,
  rmvMsgUpdtAUR,
} from "../../store/feature/adminUserRoles";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";

// Admin User Roles
const AdminUserRole = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});

  const { admUsrRole } = useAppSelector((state: RootState) => state.user);
  const { isLoadingAdmUserRoles, isLoadingEvent } = useAppSelector(
    (state: RootState) => state.admUserRoles
  );
  const { dataFGroup, msgSccsFGr } = useAppSelector(
    (state: RootState) => state.fGroup
  );

  const handleCloseToast = () => {
    dispatch(rmvMsgSccsFGr());
  };
  const handleNavigate = () => {
    dispatch(rmvMsgUpdtAUR());
    navigate("/admin-user-roles/create");
  };

  useEffect(() => {
    dispatch(getAdminUserRolesList(params));
    // console.log('isi params ===> ', params)
  }, [params]);

  return (
    <ListDataSkeleton
      isLoading={isLoadingAdmUserRoles}
      isLoadingEvent={isLoadingEvent}
      titleWidth={"300"}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: "20px" }}
        >
          Admin User Roles
        </Typography>
        {admUsrRole.uc_adm_pge_acs_create === 1 && (
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleNavigate}
              sx={{ marginBottom: "18px" }}
            >
              <AddIcon /> Create
            </Button>
          </Box>
        )}
        <AdminUserRoleSearch params={params} setParams={setParams} />
        <AdminUserRoleTable
          data={dataFGroup}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
        <Toast
          severity="success"
          open={msgSccsFGr !== ""}
          handleClose={handleCloseToast}
          message={msgSccsFGr}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default AdminUserRole;
